import { noddiAsync, URLKeys } from 'noddi-async';

/** Adapter-agnostic bookable services context for a proposal car. */
export function useProposalBookableServices({
  serviceDepartmentId,
  licensePlateNumber
}: {
  serviceDepartmentId: number | undefined;
  licensePlateNumber: string | undefined;
}) {
  const { data, error, isPending } = noddiAsync.useGet({
    type: URLKeys.getStationaryBookableServices,
    input: {
      serviceDepartmentId: serviceDepartmentId!,
      licensePlateNumber: licensePlateNumber!
    },
    queryConfig: {
      enabled: serviceDepartmentId != null && Boolean(licensePlateNumber)
    }
  });

  return {
    openOrder: data?.openOrder ?? null,
    error,
    isPending
  };
}
